module.exports = __webpack_public_path__ + "static/media/x-ray.7367c71e.svg";